import type { Density } from 'vuetify/lib/composables/density.mjs'

export enum LocalStorageKeys {
  markdownSettings = 'markdownSettings',
  savetime = 'savetime',
  density = 'style:density',
  totalFolderCount = 'totalFolderCount',
}

export const MarkdownSettings = useLocalStorage(LocalStorageKeys.markdownSettings, { minimap: false, lineNumber: true, preview: true, syncscroll: true, toc: true })
export const Savetime = useLocalStorage<number | false>(
  LocalStorageKeys.savetime,
  5,
  {
    serializer: {
      read: (value: any) => {
        const stringValue = String(value)
        if (stringValue === 'false') {
          return false
        }
        const parsed = Number.parseInt(stringValue)
        if (Number.isNaN(parsed) || ![1, 5, 10, 15, 20].includes(parsed))
          return 5
        return parsed
      },
      write: (value: any) => JSON.stringify(value),
    },
  },
)

export const density = useLocalStorage<Density>(LocalStorageKeys.density, 'compact')
export const totalFolderCount = useLocalStorage<boolean>(LocalStorageKeys.totalFolderCount, false)
